export function linkify( link: string ): string {
	if( link.startsWith('http') ) return link;
	return `https://${link}`;
}